export default __webpack_public_path__ + "static/media/pvilla1-2.d3dc0179.jpg";